//
// If on a cart page with inputs and 'update cart' button,
// detect input change event and reveal the update button
//
const cartInputs = document.querySelectorAll('[action="/cart"] input');
const cartUpdateButtons = document.querySelectorAll(
  '[name="update_cart"],[name="update"]'
);
const addVisible = e => buttons => {
  // Probably only one, but just in case
  cartUpdateButtons.forEach(button => {
    button.classList.add("visible");
  });
};
if (cartInputs && cartUpdateButtons) {
  cartInputs.forEach(input => {
    input.addEventListener("change", addVisible(cartUpdateButtons), false);
    input.addEventListener("keydown", addVisible(cartUpdateButtons), false);
  });
}
